(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8636],{

/***/ 60146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getObjectTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var _constants_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13412);




var getObjectTitle = function(object, t) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    if (!object) {
        return null;
    }
    var params = {
        operation: (ref = object.apartmentOperation) === null || ref === void 0 ? void 0 : ref.translation,
        room: object.roomCount,
        count: Number(object.roomCount || 0)
    };
    var locations = object.street ? [
        (ref1 = object.street) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.city) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.region) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.country) === null || ref4 === void 0 ? void 0 : ref4.title,
        ((ref5 = object.street) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.city) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.region) === null || ref7 === void 0 ? void 0 : ref7.title) || ((ref8 = object.alterAddress) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.division) === null || ref9 === void 0 ? void 0 : ref9.title),
        ((ref10 = object.street) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.city) === null || ref11 === void 0 ? void 0 : ref11.title) || ((ref12 = object.alterAddress) === null || ref12 === void 0 ? void 0 : ref12.cityName),
        ((ref13 = object.street) === null || ref13 === void 0 ? void 0 : ref13.title) || ((ref14 = object.alterAddress) === null || ref14 === void 0 ? void 0 : ref14.streetName),
        object.buildingNumber || ((ref15 = object.alterAddress) === null || ref15 === void 0 ? void 0 : ref15.buildingNumber), 
    ].filter(function(location) {
        return !!location;
    }) : [
        object === null || object === void 0 ? void 0 : (ref16 = object.city) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.country) === null || ref17 === void 0 ? void 0 : ref17.title,
        (object === null || object === void 0 ? void 0 : (ref18 = object.city) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.region) === null || ref19 === void 0 ? void 0 : ref19.title) || ((ref20 = object.alterAddress) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.division) === null || ref21 === void 0 ? void 0 : ref21.title),
        (object === null || object === void 0 ? void 0 : (ref22 = object.city) === null || ref22 === void 0 ? void 0 : ref22.title) || ((ref23 = object.alterAddress) === null || ref23 === void 0 ? void 0 : ref23.cityName), 
    ].filter(function(location) {
        return !!location;
    });
    if (object.apartmentNumber || ((ref24 = object.alterAddress) === null || ref24 === void 0 ? void 0 : ref24.apartmentNumber)) {
        var ref26;
        locations.push(t("object::title::apartmentNumber", {
            count: object.apartmentNumber || ((ref26 = object.alterAddress) === null || ref26 === void 0 ? void 0 : ref26.apartmentNumber)
        }));
    }
    switch((ref25 = object.apartmentType) === null || ref25 === void 0 ? void 0 : ref25.key){
        case _constants_definition__WEBPACK_IMPORTED_MODULE_0__/* .REAL_ESTATE_OBJECT_TYPES.HOUSE */ .r5.HOUSE:
            return [
                t("object::title::house", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
                    postProcess: "interval"
                }))
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(locations)).join(", ");
        case _constants_definition__WEBPACK_IMPORTED_MODULE_0__/* .REAL_ESTATE_OBJECT_TYPES.COTTAGE */ .r5.COTTAGE:
            return [
                t("object::title::cottage", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
                    postProcess: "interval"
                })), 
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(locations)).join(", ");
        case _constants_definition__WEBPACK_IMPORTED_MODULE_0__/* .REAL_ESTATE_OBJECT_TYPES.GARAGE */ .r5.GARAGE:
            return [
                t("object::title::garage", params)
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(locations)).join(", ");
        case _constants_definition__WEBPACK_IMPORTED_MODULE_0__/* .REAL_ESTATE_OBJECT_TYPES.LAND */ .r5.LAND:
            return [
                t("object::title::stead", params)
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(locations)).join(", ");
        case _constants_definition__WEBPACK_IMPORTED_MODULE_0__/* .REAL_ESTATE_OBJECT_TYPES.BUSINESS */ .r5.BUSINESS:
            return [
                t("object::title::business", params)
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(locations)).join(", ");
        case _constants_definition__WEBPACK_IMPORTED_MODULE_0__/* .REAL_ESTATE_OBJECT_TYPES.APARTMENT */ .r5.APARTMENT:
        default:
            return [
                t("object::title::apartment", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
                    postProcess: "interval"
                })), 
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(locations)).join(", ");
    }
};



/***/ }),

/***/ 46222:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82670);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7258);
/* harmony import */ var mime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13893);
/* harmony import */ var mime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mime__WEBPACK_IMPORTED_MODULE_1__);



yup__WEBPACK_IMPORTED_MODULE_0__/* .addMethod */ .kM(yup__WEBPACK_IMPORTED_MODULE_0__/* .mixed */ .nK, "file", function() {
    var errorMessage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Is not file";
    return this.test("file", errorMessage, function(value) {
        var ref = this, path = ref.path, createError = ref.createError;
        if (!value) {
            return true;
        }
        return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(value, File) || createError({
            path: path,
            message: errorMessage
        });
    });
});
yup__WEBPACK_IMPORTED_MODULE_0__/* .addMethod */ .kM(yup__WEBPACK_IMPORTED_MODULE_0__/* .mixed */ .nK, "fileExt", function(extension) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Unsupported Format";
    var extensions = extension.split(",");
    var mimes = extensions.map(function(ext) {
        return mime__WEBPACK_IMPORTED_MODULE_1___default().getType(ext);
    });
    return this.test("fileExt", errorMessage, function(value) {
        if (!value) {
            return true;
        }
        var fileExt = value.name.split(".").pop().toLowerCase();
        return mimes.includes(value.type) || extensions.includes(fileExt);
    });
});
yup__WEBPACK_IMPORTED_MODULE_0__/* .addMethod */ .kM(yup__WEBPACK_IMPORTED_MODULE_0__/* .mixed */ .nK, "fileSize", function(size) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "File too large";
    return this.test("fileSize", errorMessage, function(value) {
        if (!value) {
            return true;
        }
        return value.size <= size * 1024;
    });
});


/***/ }),

/***/ 5165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Message; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/entity/real-estate/object/write/styles.module.css
var styles_module = __webpack_require__(44037);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(25155);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var yup_es = __webpack_require__(7258);
// EXTERNAL MODULE: ./src/components/ui/textarea/index.jsx
var ui_textarea = __webpack_require__(48402);
// EXTERNAL MODULE: ./src/components/ui/upload/index.jsx
var upload = __webpack_require__(65814);
// EXTERNAL MODULE: ./src/components/ui/error/index.jsx
var error = __webpack_require__(46219);
// EXTERNAL MODULE: ./src/components/ui/button/index.jsx
var ui_button = __webpack_require__(61257);
// EXTERNAL MODULE: ./src/components/ui/footer-button-tabs/index.jsx
var footer_button_tabs = __webpack_require__(69129);
// EXTERNAL MODULE: ./src/components/ui/icons/icons/InputClearIcon.jsx
var InputClearIcon = __webpack_require__(49734);
;// CONCATENATED MODULE: ./src/components/entity/real-estate/object/write/Form.jsx













var FILE = {
    EXT: "jpg,jpeg,png,doc,pdf,gif,zip,rar,tar,txt,xls,docx,xlsx,odt",
    SIZE: 2000
};
var ACCEPT = ".jpg,.jpeg,.png,.doc,.pdf,.gif,.zip,.rar,.tar,.txt,.xls,.docx,.xlsx,.odt";
var Form = function(param) {
    var onClose = param.onClose, onSubmit = param.onSubmit;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "objectWrite"
    ]).t;
    var ref = (0,es/* useSelector */.v9)(function(param) {
        var messages = param.messages;
        return messages;
    }), isMessageSentLoading = ref.isMessageSentLoading, messageSentError = ref.messageSentError;
    var validationSchema = yup_es/* object */.Ry().shape({
        message: yup_es/* string */.Z_().required(t("validation::required")),
        file: yup_es/* mixed */.nK().file().fileExt(FILE.EXT, t("validation::fileExt", {
            ext: FILE.EXT
        })).fileSize(FILE.SIZE, t("validation::fileSize", {
            size: "2Mb"
        }))
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            message: "",
            file: null
        },
        validationSchema: validationSchema,
        onSubmit: onSubmit,
        children: function(param) {
            var values = param.values, handleChange = param.handleChange, handleBlur = param.handleBlur, handleSubmit = param.handleSubmit, setFieldValue = param.setFieldValue, errors = param.errors, resetForm = param.resetForm;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).writeMessageInputs,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).writeMessageArea,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_textarea/* default */.Z, {
                                    name: "message",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.message,
                                    maxWidth: "776px",
                                    minWidth: "100%",
                                    minHeight: "180px",
                                    maxHeight: "400px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (styles_module_default()).writeMessageFileRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (styles_module_default()).writeMessageFile,
                                            children: [
                                                values.file !== null && (0,_instanceof/* default */.Z)(values.file, File) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (styles_module_default()).writeMessageFileName,
                                                    children: values.file.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(upload/* default */.Z, {
                                                    name: "file",
                                                    setFieldValue: setFieldValue,
                                                    onRemove: function() {
                                                        setFieldValue("file", null);
                                                    },
                                                    label: t("objectWrite::addFile"),
                                                    removeLabel: t("objectWrite::removeFile"),
                                                    value: values.file,
                                                    options: {
                                                        accept: ACCEPT
                                                    },
                                                    type: upload/* UPLOAD_TYPES.SMALL */.$.SMALL,
                                                    errorMessage: errors.file
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (styles_module_default()).writeMessageFileText,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (styles_module_default()).writeMessageFileTextTop,
                                                    children: t("objectWrite::fileFormat")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (styles_module_default()).writeMessageFileTextBottom,
                                                    children: t("objectWrite::fileSize")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).writeButtonsRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).writeClear,
                                onClick: function() {
                                    resetForm();
                                    onClose();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).writeCross,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputClearIcon/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).writeText,
                                        children: t("objectWrite::clear")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).writeSend,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.ZP, {
                                    text: t("common::button::sendMessage"),
                                    size: ui_button/* BUTTON_SIZES.FLAT */.Gt.FLAT,
                                    type: ui_button/* BUTTON_TYPES.BLUE */.Dx.BLUE,
                                    isSubmit: true,
                                    disabled: isMessageSentLoading
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).writeButtonsRowMobile,
                        children: [
                            messageSentError && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* default */.Z, {
                                isOnButton: true,
                                message: messageSentError
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_button_tabs/* default */.Z, {
                                isHiddenCount: true,
                                rightLabel: t("common::button::send"),
                                leftLabel: t("common::button::clearSelect"),
                                onActionLeft: onClose
                            })
                        ]
                    }),
                    messageSentError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).errorWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* default */.Z, {
                            isOnButton: true,
                            message: messageSentError
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var write_Form = (Form);

// EXTERNAL MODULE: ./src/app/validation/yupFileValidator.js
var yupFileValidator = __webpack_require__(46222);
// EXTERNAL MODULE: ./src/components/ui/icons/index.jsx + 150 modules
var icons = __webpack_require__(20068);
;// CONCATENATED MODULE: ./src/components/entity/real-estate/object/write/Message.jsx






var WriteMessage = function(param) {
    var user = param.user, onClose = param.onClose, onSubmit = param.onSubmit, _isAuthor = param.isAuthor, isAuthor = _isAuthor === void 0 ? false : _isAuthor;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "objectWrite"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).writeMessageStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).writeMessageTitle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).writeMessageTitleText,
                        children: isAuthor ? t("objectWrite::author") : t("objectWrite::text")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).writeMessageUser,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).writeMessageUserLeft,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).writeMessageUserLogo,
                                    children: (user === null || user === void 0 ? void 0 : user.avatarUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (styles_module_default()).writeMessageUserLogoImage,
                                        src: user === null || user === void 0 ? void 0 : user.avatarUrl,
                                        alt: "user logo",
                                        width: 31,
                                        height: 31
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).writeMessageUserLogoWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* UserIcon */.tB, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (styles_module_default()).writeMessageWrapperUserName,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default()).writeMessageUserName,
                                            children: user === null || user === void 0 ? void 0 : user.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default()).writeMessageUserStatus,
                                            children: user === null || user === void 0 ? void 0 : user.isPrivate
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(write_Form, {
                onClose: onClose,
                onSubmit: onSubmit
            })
        ]
    });
};
/* harmony default export */ var Message = (WriteMessage);


/***/ }),

/***/ 65814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ UPLOAD_TYPES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30765);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25155);
/* harmony import */ var _components_ui_error__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46219);
/* harmony import */ var _components_ui_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20068);









var UPLOAD_TYPES = {
    BIG: "big",
    SMALL: "small"
};
var Upload = function(param) {
    var label = param.label, removeLabel = param.removeLabel, name = param.name, setFieldValue = param.setFieldValue, setFieldError = param.setFieldError, onBlur = param.onBlur, onRemove = param.onRemove, value = param.value, errorMessage = param.errorMessage, options = param.options, type = param.type;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)([
        "validation"
    ]).t;
    var fileRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), preview = ref[0], setPreview = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), errorText = ref1[0], setErrorText = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (typeof errorMessage === "string" && errorMessage.startsWith("validation::")) {
            setErrorText(t(errorMessage));
            return;
        }
        setErrorText(errorMessage || null);
    }, [
        errorMessage,
        t
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(value, File)) {
            if (!value.type.startsWith("image/")) {
                setPreview("preview");
                return;
            }
            var reader = new FileReader();
            reader.onloadend = function() {
                return setPreview(reader.result);
            };
            reader.readAsDataURL(value);
            return;
        }
        setPreview(value);
    }, [
        value
    ]);
    var onFileContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var ref;
        (ref = fileRef.current) === null || ref === void 0 ? void 0 : ref.click();
    }, [
        fileRef
    ]);
    var onChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var ref;
        var file = (ref = fileRef.current) === null || ref === void 0 ? void 0 : ref.files[0];
        if (!file) {
            return;
        }
        setFieldError === null || setFieldError === void 0 ? void 0 : setFieldError(name, undefined);
        setFieldValue(name, file);
    }, [
        setFieldError,
        setFieldValue,
        name
    ]);
    if (!!preview) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().upload), " ").concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadUploaded), " ").concat(!!errorText ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadWithError) : "", " ").concat(type === UPLOAD_TYPES.BIG && (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadBig), " ").concat(type === UPLOAD_TYPES.SMALL && (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadSmall)),
                        onClick: onRemove,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadWrapper),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadIcon),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_icons__WEBPACK_IMPORTED_MODULE_5__/* .CloseIcon */ .Tw, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadLink),
                                        children: removeLabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadImage),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    width: 100,
                                    height: 100,
                                    unoptimized: true,
                                    src: preview,
                                    objectFit: "cover",
                                    alt: "Uploaded image"
                                })
                            })
                        ]
                    }),
                    errorText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadErrorWrapper),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_error__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            message: errorText
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().upload), " ").concat(!!errorText ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadWithError) : "", " ").concat(type === UPLOAD_TYPES.BIG && (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadBig), " ").concat(type === UPLOAD_TYPES.SMALL && (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadSmall)),
                onClick: onFileContext,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadWrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadIcon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_icons__WEBPACK_IMPORTED_MODULE_5__/* .AddIcon */ .dt, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadLink),
                            children: label
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadFile),
                            ref: fileRef,
                            type: "file",
                            onChange: onChange,
                            name: name,
                            onBlur: onBlur
                        }, options))
                    ]
                })
            }),
            errorText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().uploadErrorWrapper),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_error__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    message: errorText
                })
            })
        ]
    });
};
Upload.propTypes = {};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(Upload));


/***/ }),

/***/ 19295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25155);
/* harmony import */ var _constants_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13412);
/* harmony import */ var _utils_formatNumbers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43495);




var useObjectPrice = function(operation, price, currency) {
    var currentCurrency = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, costCalculation = arguments.length > 4 ? arguments[4] : void 0;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "object"
    ]).t;
    var format = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!operation || !currency || !price) {
            return null;
        }
        var calcPrice = currentCurrency === null ? price : Math.ceil(price * currency.rate / currentCurrency.rate);
        var symbol = currentCurrency === null ? currency.symbol : currentCurrency.symbol;
        var priceParams = {
            price: (0,_utils_formatNumbers__WEBPACK_IMPORTED_MODULE_3__/* .numberWithSpaces */ ._)(calcPrice),
            currency: symbol
        };
        if (costCalculation === _constants_definition__WEBPACK_IMPORTED_MODULE_2__/* .ESTATE_COST_CALCULATION_TYPES.METER */ .HA.METER) {
            return t("object::priceFormatMeter", priceParams);
        } else if (costCalculation === _constants_definition__WEBPACK_IMPORTED_MODULE_2__/* .ESTATE_COST_CALCULATION_TYPES.TEN_METERS */ .HA.TEN_METERS) {
            return t("object::priceFormatTenMeter", priceParams);
        } else {
            switch(operation){
                case _constants_definition__WEBPACK_IMPORTED_MODULE_2__/* .REAL_ESTATE_OPERATION_TYPES.RENT_OUT */ .i5.RENT_OUT:
                    return t("object::priceFormat::rentOut", priceParams);
                case _constants_definition__WEBPACK_IMPORTED_MODULE_2__/* .REAL_ESTATE_OPERATION_TYPES.DAILY */ .i5.DAILY:
                    return t("object::priceFormat::daily", priceParams);
                case _constants_definition__WEBPACK_IMPORTED_MODULE_2__/* .REAL_ESTATE_OPERATION_TYPES.SELLING */ .i5.SELLING:
                default:
                    return t("object::priceFormat::selling", priceParams);
            }
        }
    }, [
        operation,
        price,
        currency,
        t,
        currentCurrency,
        costCalculation
    ]);
    return format;
};
/* harmony default export */ __webpack_exports__["Z"] = (useObjectPrice);


/***/ }),

/***/ 76563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25155);
/* harmony import */ var _app_object_getObjectTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60146);



var useObjectTitle = function(object) {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "object"
    ]).t;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,_app_object_getObjectTitle__WEBPACK_IMPORTED_MODULE_2__/* .getObjectTitle */ .t)(object, t);
    }, [
        object,
        t
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useObjectTitle);


/***/ }),

/***/ 723:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var toBase64 = function(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
            return resolve(reader.result);
        };
        reader.onerror = function(error) {
            return reject(error);
        };
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (toBase64);


/***/ }),

/***/ 44037:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"writeStyle":"styles_writeStyle__7ewvG","writeWrapper":"styles_writeWrapper__IU3MJ","writeBtn":"styles_writeBtn__9Hiis","writeBlock":"styles_writeBlock__s0xUn","writeTitle":"styles_writeTitle__m92t_","writeAddress":"styles_writeAddress__cH7CR","writePrice":"styles_writePrice__q1ODl","writeSwitcher":"styles_writeSwitcher__m86sW","writeSwitcherWrapper":"styles_writeSwitcherWrapper__eboDQ","writeSwitcherInfo":"styles_writeSwitcherInfo__QY49B","writeSuccess":"styles_writeSuccess__SrSON","writeSuccessSubtitle":"styles_writeSuccessSubtitle__BJOSX","writeMessageStyle":"styles_writeMessageStyle__oiEd_","writeMessageTitle":"styles_writeMessageTitle__ElwmG","writeMessageTitleText":"styles_writeMessageTitleText__CMUvs","writeMessageUser":"styles_writeMessageUser__bhN0n","writeMessageUserLeft":"styles_writeMessageUserLeft__BNfrC","writeMessageWrapperUserName":"styles_writeMessageWrapperUserName__8d6E_","writeMessageUserLogo":"styles_writeMessageUserLogo__DOrk5","writeMessageUserLogoImage":"styles_writeMessageUserLogoImage__P9nex","writeMessageUserLogoWrapper":"styles_writeMessageUserLogoWrapper__gEkrW","writeMessageUserName":"styles_writeMessageUserName__kvwXI","writeMessageUserStatus":"styles_writeMessageUserStatus__F_SAh","writeMessageInputs":"styles_writeMessageInputs__AawXd","writeMessageArea":"styles_writeMessageArea__dlFSG","writeMessageFileRow":"styles_writeMessageFileRow__BIXVs","writeMessageFile":"styles_writeMessageFile__BrM6n","writeMessageFileName":"styles_writeMessageFileName__xing9","writeMessageFileText":"styles_writeMessageFileText__eCvaZ","writeMessageFileTextTop":"styles_writeMessageFileTextTop__6HqAF","writeMessageFileTextBottom":"styles_writeMessageFileTextBottom__hOjyp","writeButtonsRow":"styles_writeButtonsRow__ZpiCb","writeButtonsRowMobile":"styles_writeButtonsRowMobile__5_W13","writeClear":"styles_writeClear__gwiBJ","writeCross":"styles_writeCross__3rC6I","writeText":"styles_writeText__ftGCs","writeSend":"styles_writeSend__Fs_ju","errorWrapper":"styles_errorWrapper__mVo6o"};

/***/ }),

/***/ 30765:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upload":"styles_upload__ntxgn","uploadUploaded":"styles_uploadUploaded__p_uFs","uploadWithError":"styles_uploadWithError__bRHqV","uploadSmall":"styles_uploadSmall__vbCOQ","uploadIcon":"styles_uploadIcon__mmMK6","uploadWrapper":"styles_uploadWrapper__f8GMD","uploadLink":"styles_uploadLink__OILcH","uploadImage":"styles_uploadImage__VbM6h","uploadBig":"styles_uploadBig__4yQ1x","uploadFile":"styles_uploadFile__68d7_","uploadErrorWrapper":"styles_uploadErrorWrapper__REElT"};

/***/ })

}]);